unit Predlog;

interface

uses
  System.SysUtils, System.Classes, Vcl.Forms, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls, Data.DB, TerminalForm,
  WEBLib.ExtCtrls;

type
  TfrmPredlog = class(TForm)
    btnCiscenje: TButton;
    btnCancelPredlog: TButton;
    btnKante: TButton;
    panNotes: TPanel;
    WebLabel5: TLabel;
    memoNotes: TMemo;
    panNotesButtons: TGridPanel;
    btnOpomba1: TButton;
    btnOpomba2: TButton;
    btnOpomba3: TButton;
    btnDelNote: TButton;
    procedure FormShow(Sender: TObject);
    procedure btnCancelPredlogClick(Sender: TObject);
    procedure btnOkClick(Sender: TObject);
    procedure btnCiscenjeClick(Sender: TObject);
    procedure btnMenjavaClick(Sender: TObject);
    procedure btnKanteClick(Sender: TObject);
    procedure btnDelNoteClick(Sender: TObject);
    procedure memoNotesChange(Sender: TObject);
  private
    { Private declarations }
    procedure ApplyTheme; reintroduce;
  public
    { Public declarations }
    //LokacijaId: integer;
    Izbor: integer;

    //constructor Create(Owner: TComponent; ALokacijaId: integer); overload;
    //procedure Center;
  protected procedure LoadDFMValues; override; end;

var
  frmPredlog: TfrmPredlog;

implementation

{$R *.dfm}

uses Main, Client.Core, Client.Settings, Client.Constants;

procedure TfrmPredlog.ApplyTheme;
begin
  inherited;
end;

procedure TfrmPredlog.btnCancelPredlogClick(Sender: TObject);
begin
  inherited;
  ModalResult := mrCancel;
end;

procedure TfrmPredlog.btnCiscenjeClick(Sender: TObject);
begin
  modMain.PredlogPranje(modMain.LokacijaId, 0, Ord(npsPredlog), memoNotes.Text);
  Close;
end;

procedure TfrmPredlog.btnDelNoteClick(Sender: TObject);
begin
  memoNotes.Clear;
end;

procedure TfrmPredlog.btnKanteClick(Sender: TObject);
begin
 // Frakcija + dimenzija
 // Pošlji
//  modMain.PredlogKanta(modMain.LokacijaId, memoNotes.Text);
  Close;
end;

procedure TfrmPredlog.btnMenjavaClick(Sender: TObject);
begin
  Close;
end;

procedure TfrmPredlog.btnOkClick(Sender: TObject);
begin
  inherited;
  Close;
end;

procedure TfrmPredlog.FormShow(Sender: TObject);
begin
  inherited;
  Left := (Window.InnerWidth - Width) div 2;
  Top := (Window.InnerHeight - Height) div 2;

  ApplyTheme;
end;

procedure TfrmPredlog.memoNotesChange(Sender: TObject);
begin
  btnKante.Enabled := memoNotes.Text<>'';
end;

procedure TfrmPredlog.LoadDFMValues;
begin
  inherited LoadDFMValues;

  btnCiscenje := TButton.Create(Self);
  btnCancelPredlog := TButton.Create(Self);
  btnKante := TButton.Create(Self);
  panNotes := TPanel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  memoNotes := TMemo.Create(Self);
  panNotesButtons := TGridPanel.Create(Self);
  btnOpomba1 := TButton.Create(Self);
  btnOpomba2 := TButton.Create(Self);
  btnOpomba3 := TButton.Create(Self);
  btnDelNote := TButton.Create(Self);

  btnCiscenje.BeforeLoadDFMValues;
  btnCancelPredlog.BeforeLoadDFMValues;
  btnKante.BeforeLoadDFMValues;
  panNotes.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  memoNotes.BeforeLoadDFMValues;
  panNotesButtons.BeforeLoadDFMValues;
  btnOpomba1.BeforeLoadDFMValues;
  btnOpomba2.BeforeLoadDFMValues;
  btnOpomba3.BeforeLoadDFMValues;
  btnDelNote.BeforeLoadDFMValues;
  try
    Name := 'frmPredlog';
    Width := 478;
    Height := 709;
    Color := clBtnFace;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -27;
    Font.Name := 'Segoe UI';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'FormShow');
    btnCiscenje.SetParentComponent(Self);
    btnCiscenje.Name := 'btnCiscenje';
    btnCiscenje.AlignWithMargins := True;
    btnCiscenje.Left := 10;
    btnCiscenje.Top := 332;
    btnCiscenje.Width := 458;
    btnCiscenje.Height := 118;
    btnCiscenje.Margins.Left := 10;
    btnCiscenje.Margins.Right := 10;
    btnCiscenje.Align := alTop;
    btnCiscenje.Caption := '<span style="font-size:40px;">Potrebno je '#269'i'#353#269'enje</span>';
    btnCiscenje.ChildOrder := 1;
    btnCiscenje.ElementClassName := 'btn btn-primary';
    btnCiscenje.ElementFont := efCSS;
    btnCiscenje.HeightPercent := 100.000000000000000000;
    btnCiscenje.WidthPercent := 100.000000000000000000;
    SetEvent(btnCiscenje, Self, 'OnClick', 'btnCiscenjeClick');
    btnCancelPredlog.SetParentComponent(Self);
    btnCancelPredlog.Name := 'btnCancelPredlog';
    btnCancelPredlog.AlignWithMargins := True;
    btnCancelPredlog.Left := 10;
    btnCancelPredlog.Top := 588;
    btnCancelPredlog.Width := 458;
    btnCancelPredlog.Height := 118;
    btnCancelPredlog.Margins.Left := 10;
    btnCancelPredlog.Margins.Right := 10;
    btnCancelPredlog.Align := alBottom;
    btnCancelPredlog.Caption := '<span class="material-icons" style="font-size:40px;">keyboard_backspace</span><span style="font-size:40px;">Zapri</span>';
    btnCancelPredlog.ChildOrder := 1;
    btnCancelPredlog.ElementClassName := 'btn btn-danger';
    btnCancelPredlog.ElementFont := efCSS;
    btnCancelPredlog.HeightPercent := 100.000000000000000000;
    btnCancelPredlog.WidthPercent := 100.000000000000000000;
    SetEvent(btnCancelPredlog, Self, 'OnClick', 'btnCancelPredlogClick');
    btnKante.SetParentComponent(Self);
    btnKante.Name := 'btnKante';
    btnKante.AlignWithMargins := True;
    btnKante.Left := 10;
    btnKante.Top := 456;
    btnKante.Width := 458;
    btnKante.Height := 118;
    btnKante.Margins.Left := 10;
    btnKante.Margins.Right := 10;
    btnKante.Align := alTop;
    btnKante.Caption := '<span style="font-size:40px;">Po'#353'kodovana posoda</span>';
    btnKante.ChildOrder := 1;
    btnKante.ElementClassName := 'btn btn-primary';
    btnKante.ElementFont := efCSS;
    btnKante.HeightPercent := 100.000000000000000000;
    btnKante.WidthPercent := 100.000000000000000000;
    SetEvent(btnKante, Self, 'OnClick', 'btnKanteClick');
    panNotes.SetParentComponent(Self);
    panNotes.Name := 'panNotes';
    panNotes.Left := 0;
    panNotes.Top := 0;
    panNotes.Width := 478;
    panNotes.Height := 329;
    panNotes.ElementClassName := 'card';
    panNotes.Align := alTop;
    panNotes.Caption := 'panNotes';
    panNotes.ChildOrder := 8;
    panNotes.ElementBodyClassName := 'card-body';
    panNotes.ElementFont := efCSS;
    panNotes.TabOrder := 3;
    WebLabel5.SetParentComponent(panNotes);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 0;
    WebLabel5.Top := 0;
    WebLabel5.Width := 478;
    WebLabel5.Height := 33;
    WebLabel5.Align := alTop;
    WebLabel5.Caption := 'Opombe';
    WebLabel5.ElementFont := efCSS;
    WebLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLabel5.Font.Color := clWindowText;
    WebLabel5.Font.Height := -27;
    WebLabel5.Font.Name := 'Tahoma';
    WebLabel5.Font.Style := [];
    WebLabel5.HeightStyle := ssAuto;
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.ParentFont := False;
    WebLabel5.WidthPercent := 100.000000000000000000;
    memoNotes.SetParentComponent(panNotes);
    memoNotes.Name := 'memoNotes';
    memoNotes.Left := 0;
    memoNotes.Top := 33;
    memoNotes.Width := 478;
    memoNotes.Height := 196;
    memoNotes.Align := alClient;
    memoNotes.ElementClassName := 'form-control fs-2';
    memoNotes.ElementFont := efCSS;
    memoNotes.Font.Charset := DEFAULT_CHARSET;
    memoNotes.Font.Color := clWindowText;
    memoNotes.Font.Height := -27;
    memoNotes.Font.Name := 'Tahoma';
    memoNotes.Font.Style := [];
    memoNotes.HeightPercent := 100.000000000000000000;
    memoNotes.ParentFont := False;
    memoNotes.SelLength := 0;
    memoNotes.SelStart := 0;
    memoNotes.WidthPercent := 100.000000000000000000;
    SetEvent(memoNotes, Self, 'OnChange', 'memoNotesChange');
    panNotesButtons.SetParentComponent(panNotes);
    panNotesButtons.Name := 'panNotesButtons';
    panNotesButtons.Left := 0;
    panNotesButtons.Top := 229;
    panNotesButtons.Width := 478;
    panNotesButtons.Height := 100;
    panNotesButtons.Align := alBottom;
    panNotesButtons.ChildOrder := 4;
    panNotesButtons.ColumnCollection.Clear;
    with panNotesButtons.ColumnCollection.Add do
    begin
      MarginLeft := 3;
      MarginRight := 3;
      Value := 33;
    end;
    with panNotesButtons.ColumnCollection.Add do
    begin
      MarginLeft := 3;
      MarginRight := 3;
      Value := 33;
    end;
    with panNotesButtons.ColumnCollection.Add do
    begin
      MarginLeft := 3;
      MarginRight := 3;
      Value := 33;
    end;
    panNotesButtons.ControlCollection.Clear;
    with panNotesButtons.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := btnOpomba1;
    end;
    with panNotesButtons.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := btnOpomba2;
    end;
    with panNotesButtons.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := btnOpomba3;
    end;
    panNotesButtons.Color := clWhite;
    panNotesButtons.GridLineColor := clBlack;
    panNotesButtons.RowCollection.Clear;
    with panNotesButtons.RowCollection.Add do
    begin
      Value := 100;
    end;
    panNotesButtons.Visible := False;
    btnOpomba1.SetParentComponent(panNotesButtons);
    btnOpomba1.Name := 'btnOpomba1';
    btnOpomba1.AlignWithMargins := True;
    btnOpomba1.Left := 5;
    btnOpomba1.Top := 2;
    btnOpomba1.Width := 148;
    btnOpomba1.Height := 96;
    btnOpomba1.Align := alClient;
    btnOpomba1.Caption := 'Opomba 1';
    btnOpomba1.ChildOrder := 2;
    btnOpomba1.ElementClassName := 'btn btn-xxl btn-primary shadow d-inline-block text-truncate';
    btnOpomba1.ElementFont := efCSS;
    btnOpomba1.HeightStyle := ssAuto;
    btnOpomba1.HeightPercent := 100.000000000000000000;
    btnOpomba1.WidthPercent := 100.000000000000000000;
    btnOpomba2.SetParentComponent(panNotesButtons);
    btnOpomba2.Name := 'btnOpomba2';
    btnOpomba2.AlignWithMargins := True;
    btnOpomba2.Left := 163;
    btnOpomba2.Top := 2;
    btnOpomba2.Width := 148;
    btnOpomba2.Height := 96;
    btnOpomba2.Align := alClient;
    btnOpomba2.Caption := 'Opomba 2';
    btnOpomba2.ChildOrder := 2;
    btnOpomba2.ElementClassName := 'btn btn-xxl btn-primary shadow';
    btnOpomba2.ElementFont := efCSS;
    btnOpomba2.HeightStyle := ssAuto;
    btnOpomba2.HeightPercent := 100.000000000000000000;
    btnOpomba2.WidthPercent := 100.000000000000000000;
    btnOpomba3.SetParentComponent(panNotesButtons);
    btnOpomba3.Name := 'btnOpomba3';
    btnOpomba3.AlignWithMargins := True;
    btnOpomba3.Left := 321;
    btnOpomba3.Top := 2;
    btnOpomba3.Width := 148;
    btnOpomba3.Height := 96;
    btnOpomba3.Align := alClient;
    btnOpomba3.Caption := 'Opomba 3';
    btnOpomba3.ChildOrder := 2;
    btnOpomba3.ElementClassName := 'btn btn-xxl btn-primary shadow';
    btnOpomba3.ElementFont := efCSS;
    btnOpomba3.HeightStyle := ssAuto;
    btnOpomba3.HeightPercent := 100.000000000000000000;
    btnOpomba3.WidthPercent := 100.000000000000000000;
    btnDelNote.SetParentComponent(panNotes);
    btnDelNote.Name := 'btnDelNote';
    btnDelNote.AlignWithMargins := True;
    btnDelNote.Left := 409;
    btnDelNote.Top := 39;
    btnDelNote.Width := 59;
    btnDelNote.Height := 62;
    btnDelNote.Margins.Right := 10;
    btnDelNote.Anchors := [akTop,akRight];
    btnDelNote.Caption := '<i class="material-icons">backspace</i>';
    btnDelNote.ChildOrder := 2;
    btnDelNote.ElementClassName := 'btn btn-xxl btn-primary shadow';
    btnDelNote.ElementFont := efCSS;
    btnDelNote.HeightPercent := 100.000000000000000000;
    btnDelNote.WidthPercent := 100.000000000000000000;
    SetEvent(btnDelNote, Self, 'OnClick', 'btnDelNoteClick');
  finally
    btnCiscenje.AfterLoadDFMValues;
    btnCancelPredlog.AfterLoadDFMValues;
    btnKante.AfterLoadDFMValues;
    panNotes.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    memoNotes.AfterLoadDFMValues;
    panNotesButtons.AfterLoadDFMValues;
    btnOpomba1.AfterLoadDFMValues;
    btnOpomba2.AfterLoadDFMValues;
    btnOpomba3.AfterLoadDFMValues;
    btnDelNote.AfterLoadDFMValues;
  end;
end;

end.
